import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from "@mui/material/IconButton";
import DoneIcon from '@mui/icons-material/Done';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from '@mui/icons-material/Add';
import Popper from '@mui/material/Popper';
import Bs4ModalTopCenter from '../../Bs4Components/Bs4ModalTopCenter';

import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4GenericField from './Bs4GenericField';
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4I18N from '../../Bs4I18N';
import { SmallScreenContext } from '../../Bs4Theme/Bs4UxTemplates';

const minSearchTextLength = 3;

export default class WyborMultiple extends Bs4GenericField {

  canCloseCriteria = false;

  atrybOnchange = Bs4GenericField.CHANGE;
  
  //spodziewana tablica elementów [{id:.., name:...}, ...]
  setValueBs4(value) {    
    if (Array.isArray(value)) {
      this.setValue(value.filter(item => Boolean(item?.id)));
    } else if (value) {
      const values = value.split(',').map(id => parseInt(id));
      this.setValueIds(values);
    } else {
      this.setValue([]);
    }
  }

  //zwraca tablicę ids [id0, id1, ...]
  getValueBs4() {
    if (Array.isArray(this.value)) return this.value.map(row => {
      if (row?.id) return row.id;
      return row;
    })
    return this.value
  }

  elementAddValue(value) {
    const ids = this.getValueBs4();
    ids.push(''+value );
    this.setValueIds(ids);
  };

  isNativelyClearable () {
    return true;
  }

  getShortValue = (full) => {
    let trueValues = 0;
    let shortValue = '';
    let separator = '';

    (this.getValue() || []).forEach((item) => {
      trueValues++;
      shortValue += separator+item.name;
      separator = ', ';
    });    
    
    if (full) return shortValue;
    
    if (trueValues > 1) {
      return '('+trueValues+')';
    } 
    
    if (shortValue.length > 20) {
      return shortValue.substring(0, 17)+'...';
    }

    return shortValue;						
  }

  setValueIds (newValueIds) {
    const valueMap = new Map(this.getValue().map(value => [value.id, value.name]));
    //Większość ids już jest w value, mają poprawne nazwy, które wystarczy skopiować.
    //Zostaną pobrane z serwaera tylko nowe nazwy (najczęściej jedna) i zaktualizowane po zakończeniu pobierania.
    //Program z nazwami tymczasowymi (id) działa natychmiast dalej.
    const newIds = [];
    const newValue = newValueIds.map(id => {
      const name = valueMap.get(id);
      if (!name) newIds.push(id);
      return {
        id: id,
        name: name || id,
      }          
    })

    this.setValue(newValue);
    return this.getData(newIds, null);    
  }

  getData (currentFormElementValue, inputValue) {
    return new Promise((resolve, reject) => {
      const url = Bs4MainDispatch.getUrlPath('web.php')
      const data = { 
        com: 'Bs4SearchText',
        currFormId: this.props.field.formId,
        inputId: this.props.inputId,
        currCardViewId: null,
        currOptionId: this.props.optionId,
        page: 1,
        start: 0,
        limit: 200,
      }

      const newData = Bs4MainDispatch.getParserParams(data, this.props.bs4KartotekaId)

      const queryUrl = new URLSearchParams();
      queryUrl.append('com', 'Bs4SearchText');
      queryUrl.append('currFormId', newData.currFormId);
      queryUrl.append('_dc', Date.now());
      queryUrl.append('inputId', newData.inputId);      
      queryUrl.append('currCardViewId', newData.currCardViewId);
      queryUrl.append('currOptionId', newData.currOptionId);
      if (currentFormElementValue) 
        queryUrl.append('currentFormElementValue', JSON.stringify(currentFormElementValue));
      if (inputValue) 
        queryUrl.append('query', inputValue);
      queryUrl.append('page', newData.page);
      queryUrl.append('start', newData.start);
      queryUrl.append('limit', newData.limit);    

      fetch(url+'?'+queryUrl.toString())
      .then(response => {
        return response.text();
      })
      .then(returnedText => {
        try {
          const returnedJson = JSON.parse(returnedText);
          if (currentFormElementValue) {
            const dataMap = new Map(returnedJson.messgs.data.map(object => {
              return [String(object.id), object.name];
            }));
            const newValue = this.value.map(row => {
              const name = dataMap.get(String(row.id));
              if (name) row.name = name;
              return row;
            })
            this.setValue(newValue);
          } else {
            this.trigger(WyborMultiple.CHANGE_OPTIONS_MULTIPLE, this, inputValue, returnedJson.messgs.data);
          }
          resolve(true);
        } catch (error) {          
          console.log(returnedText, data);
          console.log(error);
          reject(error)
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error)
      });
    });
  }

  getValueOptions(value, options) {
    if (!value) return options;
    const valueIds = value.map(val => val.id)
    return [...value, ...options.filter(option => !valueIds.includes(option.id))]
  }

  ChipOptionLabel = (props) => {    
    const formField = this;
    const handleClick = (event) => {
      Bs4MainDispatch.commandParser('Bs4FormFieldValue', {bs4multiselected: props.option.id, currFormId: this.props.field.formId}, this.bs4KartotekaId);
    }

    if (this.isParamSelected('LINKVALUE')) return (
      <Link href='#' onClick={handleClick}>{props.option.name}</Link>
    );
    else return <Box component='span'>{props.option.name}</Box>
  }   

  dragStartOption = null;
  dragOverOption = null;

  reorderDraggableOptions(event, option, value, setValue) {
    if (! this.dragStartOption) return;
    if (this.dragStartOption === option) return;
    if (this.dragOverOption === option) return;

    const valueWithoutDraggedOption = value.filter(option => option !== this.dragStartOption);
    if (option === "INPUT") {
      valueWithoutDraggedOption.push(this.dragStartOption);
    } else {
      valueWithoutDraggedOption.splice(valueWithoutDraggedOption.indexOf(option), 0, this.dragStartOption);
    }
    setValue(valueWithoutDraggedOption);
    this.dragOverOption = option;
  }

  PopperStandard = (props) => {      
        return (<Popper {...props} style={{ width: 250 }} placement='bottom-start'/>)
      }
      
  PopperDialogFlat = (props) => {
    return (
      <Box {...props.style} width={'100%'}>
        {props.children}
      </Box>
    )
  }

  PopperDialog = (props) => {
    const formField = this;
      
    return (
      <Bs4ModalTopCenter
        bs4KartotekaId={formField.bs4KartotekaId}
        open={props.open}
        onClose={props.onClose}
      >
        <formField.ViewComponentField {...props} variantDialog/>
      </Bs4ModalTopCenter>
    )
  }

  ViewComponentField = (props) => {
    const formField = this;
    const theme = useTheme()
    const [value, setValue] = React.useState(() => this.getValue());    
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    const [options, setOptions] = React.useState([]);
    const [inputValue, setInputValue] = React.useState('');
    const [open, setOpen] = React.useState(false);    
    const [loading, setLoading] = React.useState(false);    
    const [
      enterTextOrClickTheSearchIcon, 
      noResultsFound
    ] = Bs4I18N.useTTA([
      ['Enter text or click the search icon', 'Wpisz szukany tekst lub kliknij lupę', 'KontrolkaWybor'],
      ['No results found', 'Nie znaleziono wyników', 'KontrolkaWybor'],
    ])
    
    this.refFocus = React.useRef();

    // const [open, setOpen] = React.useState(false);
    const smallScreen = React.useContext(SmallScreenContext);
    const popper = React.useMemo(() => {
      if (props.variantDialog) return this.PopperDialogFlat;
      if (smallScreen) return this.PopperDialog;
      return this.PopperStandard;
    }, [smallScreen, props.variantDialog]);

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})} 
      this.on(WyborMultiple.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })
      
      this.on(WyborMultiple.CHANGE_OPTIONS_MULTIPLE, (field, query, options) => {
        setLoading(false)
        setOptions(options || []);
      })       
    }, [error]);

    const canOpen = () => {
      const inputValueOk = inputValue && inputValue.length > 2;
      const optionsOk = options && options.length > 0;
      return open && (inputValueOk || optionsOk);
    }

    const handleSearch = (e) => {
      const bs4Kartoteka = Bs4Kartoteka.get(this.props.bs4KartotekaId);
      bs4Kartoteka.sourceField = {query: 'search_multiple', field: this}
      Bs4MainDispatch.commandParser('Bs4FieldIconSearch', { currFormId: this.props.field.formId, inputId: this.props.field.inputId}, this.props.bs4KartotekaId);      
    }

    const handleAdd = (e) => {
      Bs4MainDispatch.commandParser('Bs4FieldIconPlus', { currFormId: this.props.field.formId }, this.props.bs4KartotekaId);
    }    

    const handleInputChange = (event, newValue) => {
      setInputValue(newValue)
    }    
    
    const getNoOptionsText = () => {
      return (inputValue || '').length < minSearchTextLength ? enterTextOrClickTheSearchIcon : noResultsFound;
    }

    React.useEffect(() => {
      if (inputValue && inputValue?.length > 0 && inputValue?.length < minSearchTextLength) return;
      // if (!inputValue || inputValue.length < minSearchTextLength) return;
      // console.log('...???...wm', inputValue);
      this.getData(null, inputValue);
      setLoading(true)

    }, [inputValue]);

    const getAdornment = (variantDialog, onClose) => { 
      if (formField.readOnly) return null;
      return (    
        <Stack direction="row" spacing={0} sx={{justifyContent: "space-between", alignItems: "center", width: variantDialog ? '100%' : 'auto', padding: variantDialog? 1 : 0}}>
          <Box 
            display='flex' 
            direction='column' 
            // sx={{border:"solid blue"}}
          >
            {this.props.noSearch ? null : <IconButton onClick={handleSearch}><SearchIcon fontSize='small'/></IconButton>}
            {formField.isParamSelected('ATRYB_PLUS') ? <IconButton onClick={handleAdd}><AddIcon fontSize='small'/></IconButton> : null}          
          </Box>
          {variantDialog ? 
            <Button 
              onMouseDown={(e) => e.preventDefault()} // prevent blur
              onClick={(e) => {
                // e.preventDefault(); // prevent blur
                onClose(e, 'OK');
              }}
            >
              {'Ok'}
            </Button> 
          : null}
        </Stack>  
      )
    }

    //console.log('...WyborMultiple...view..', value, this.getValueOptions(value, options))
    const handleChipMouseDown = (event, option) => {
      //console.log('... drag', event.type, event, option)
      event.stopPropagation()
    }    

    const handleChipDragStart = (event, option) => {
      //console.log('... drag', event.type, event, option)
      formField.dragStartOption = option;
      event.target.style.opacity = '0.2';
    }

    const handleChipDragEnd = (event, option) => {
      formField.dragStartOption = null;
      event.target.style.opacity = '1';
      this.setValue(value);
    }

    const handleChipDragOver = (event, option) => {      
      if (event.target.nodeName !== "SPAN") return;
      formField.reorderDraggableOptions(event, option, value, setValue)
    }

    const handleChipDragOverTF = (event) => {
      if (event.target.nodeName !== "INPUT") return;
      formField.reorderDraggableOptions(event, "INPUT", value, setValue)
    }

    const handleOpenAutocomplete = React.useCallback((event) => {
          setOpen(true);
        }, [setOpen]);
    
    const handleCloseAutocomplete = React.useCallback((event, reason) => {
      if ((reason === 'blur' || reason === 'toggleInput') && popper === this.PopperDialog) return;  
      setOpen(false);
      if (props.onClose) props.onClose(event, reason);
    }, [setOpen, popper]);
    

    return (
      <Box 
        id={this.props.inputId}
        width='100%' 
        sx={{display: 'flex', alignItems: 'flex-end', flexWrap: 'wrap'}}        
      >
        <Autocomplete
          readOnly={formField.readOnly}
          //freeSolo={formField.readOnly}
          // fullWidth           
          sx={{flex: 1}}
          multiple
          disableCloseOnSelect
          value={value}
          onChange={(event, newValue) => {formField.setValue(newValue)}}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          // open={canOpen()}
          open={canOpen() || Boolean(props.variantDialog)}
          onOpen={handleOpenAutocomplete}
          onClose={handleCloseAutocomplete}
          options={this.getValueOptions(value, options)}
          loading={loading}
          getOptionLabel={option => option?.name || ''}
          popupIcon={null} // bez popup
          isOptionEqualToValue={(option, value) => option.id === value.id}
          noOptionsText={getNoOptionsText()}
          renderInput={(params) => {
            params.InputProps.disableUnderline = formField.readOnly;
            return (
            <TextField 
              {...params} 
              label={<formField.Bs4Label/>}
              slotProps={{inputLabel: formField.props.field.hideLabel ? {sx:{display:'none'}} : null}}
              inputRef={formField.refFocus} 
              error={error.error} 
              helperText={error.helperText}
              onDragOver={(e) => handleChipDragOverTF(e)}
              sx={{flex: 1}}
            />
          )}}
          renderOption={(props, option, { selected }) => (
            <MenuItem {...props} key={option.id}>
              <DoneIcon htmlColor={selected ? theme.palette.primary.main : 'transparent'}/>
              <span>&nbsp;</span>              
              <ListItemText primary={option.name}/>
            </MenuItem>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip                
                {...getTagProps({index})} 
                key={option.id}
                label={<formField.ChipOptionLabel option={option}/>}
                draggable
                onMouseDown={(e) => handleChipMouseDown(e, option)}
                onDragStart={(e) => handleChipDragStart(e, option)}
                onDragEnd={(e) => handleChipDragEnd(e, option)}
                onDragOver={(e) => handleChipDragOver(e, option)}
              />
            ))
          }
          slots={{
            // paper: formField.PaperComponent,
            popper: popper,
          }} 
          slotProps={{
            // paper: {
            //   value: value,
            //   onClose: handleCloseAutocomplete,
            //   bs4config: {variantDialog: props.variantDialog},
            // },
            popper: {        
              sx: { minWidth: 'fit-content' },
              onClose: handleCloseAutocomplete,
            }
          }}    
          // componentsProps={{ 
          //   popper: { 
          //     sx: { minWidth: 'fit-content' },
          //     placement: "bottom-start",
          //   }
          // }} 
        />     
        {getAdornment(props.variantDialog, handleCloseAutocomplete)}
      </Box>
    );
  }
}